// @flow

import React from 'react';
// import {makeStyles} from '@material-ui/core';
// import CustomButton from '../../../../elements/CustomButton/CustomButton';
// import {useFormContext} from 'react-hook-form';
// import {colors} from '../../../../assets/styles/colors';
import HeaderTab from './HeaderTab';
import {PRODUCT_TABS} from '../../constants';
import {useStoreBusinessModel, useStoreInfo} from '../../../store/utils';
import {isFeatureInTier} from '../../../../utils/component';

type Props = {
  tabSelected: string,
  onTabSelected: (v: string) => void,
};

// const useStyles = makeStyles(theme => ({
//   tabButton: {
//     borderRadius: '8px',
//     color: colors.grey900,
//     fontSize: 16,
//     fontWeight: 600,
//     textTransform: 'none',
//     width: 'fit-content',
//     [theme.breakpoints.down('md')]: {
//       width: '100%',
//       flexBasis: '100%',
//     },
//   },
//   active: {
//     backgroundColor: '#FFFFFF',
//     color: '#7B39FF',
//   },
// }));

const ProductHeaderTabs = ({tabSelected, onTabSelected}: Props) => {
  const businessModel = useStoreBusinessModel();
  const store = useStoreInfo();

  return (
    <>
      {PRODUCT_TABS.filter(tab => {
        return tab.storeBusinessModels.includes(businessModel);
      })
        .filter(tab => {
          if (!tab.storeFeatures) return true;
          return tab.storeFeatures.every(feature => {
            return isFeatureInTier(feature, store);
          });
        })
        .map((el, idx) => (
          <HeaderTab
            key={el.key}
            tab={el}
            active={el.key === tabSelected}
            onTabSelected={() => onTabSelected(el.key)}
            idx={idx}
          />
        ))}
    </>
  );
};

export default ProductHeaderTabs;
